import {
  ISectionOptions,
  Paragraph,
  ParagraphChild,
  SectionType,
  TextRun,
} from 'docx'
import { createHyperlink, formatLocation } from './common'
import { Resume } from '@/types/resume/v1'

const getContactInfo = (basics: Resume.Basics) => {
  const contact: string[] = []

  if (basics.location) contact.push(formatLocation(basics.location))
  if (basics.phone) contact.push(basics.phone)

  return contact
}

const getWebPresence = (basics: Resume.Basics): ParagraphChild[] => {
  const webPresence: ParagraphChild[] = []

  if (basics.email) {
    webPresence.push(createHyperlink(basics.email, `mailto:${basics.email}`))
    webPresence.push(new TextRun(' | '))
  }

  if (basics.url) {
    webPresence.push(createHyperlink(basics.url, basics.url))
    webPresence.push(new TextRun(' | '))
  }

  return webPresence
}

const getContact = (basics: Resume.Basics): Paragraph[] => {
  const children: Paragraph[] = []

  const webPresence = getWebPresence(basics)

  if (webPresence.length) {
    webPresence.pop()
    children.push(
      new Paragraph({
        children: webPresence,
        style: 'basicsContact',
      })
    )
  }

  const urls = (basics.profiles || []).reduce<ParagraphChild[]>(
    (acc, profile) => {
      if (profile.url) {
        acc.push(createHyperlink(profile.url, profile.url))
        acc.push(new TextRun(' | '))
      }
      return acc
    },
    []
  )

  if (urls.length) {
    urls.pop()
    children.push(
      new Paragraph({
        children: urls,
        style: 'basicsContact',
      })
    )
  }

  const contactInfo = getContactInfo(basics)
  if (contactInfo.length) {
    children.push(
      new Paragraph({
        children: [new TextRun({ text: contactInfo.join(' | ') })],
        style: 'basicsContact',
      })
    )
  }

  return children
}

export default (basics: Resume.Basics): ISectionOptions[] => {
  const header: ISectionOptions = {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: basics.name,
        style: 'basicsName',
      }),
      new Paragraph({
        text: basics.label,
        style: 'basicsLabel',
      }),
      ...getContact(basics),
    ],
  }

  const summary: ISectionOptions = {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: basics.summary,
      }),
    ],
  }

  return [header, summary]
}
